import { Accordion, AccordionDetails, Divider, Grid, Typography } from "@mui/material";
import AccordionSummarySlim from "components/Common/AccordionSummarySlim";
import CheckBoxForm from "components/Common/CheckBoxForm";
import { useTranslations } from "@fenetech/translations";
import React, { useCallback } from 'react';
import { useFieldArray, useFormContext } from "react-hook-form";
import { GetEnumAsListOfKeyValuePairs } from "helpers/objects";
import { SecurityLevelEnum } from "helpers/enums";
import SelectForm from "components/Common/SelectForm";

interface IProps {
    readOnly: boolean,
    disabled: boolean,
    securityLevelDisabled: boolean
}

const PermissionSelect: React.FC<IProps> = ({ readOnly, disabled, securityLevelDisabled }: IProps) => {

    const { control, watch, setValue, resetField } = useFormContext();

    const { fields } = useFieldArray({
        control: control,
        name: "permissions"
    });

    const tm = useTranslations();
    const [isExpanded, setIsEpanded] = React.useState<boolean>(true);

    const handleSecurityLevelChange = useCallback((data) => {
        if (data.target.value === SecurityLevelEnum.Administrator) {
            const permissions = watch("permissions");
            for (var i = 0; i < permissions.length; i++) {
                setValue(`permissions.${i}.enabled`, true);
            }
            setValue("isAllWebCustomers", true);
        } else {
            resetField("permissions");
            resetField("isAllWebCustomers");
        }
    }, [watch, resetField, setValue]);

    return <>
        <Accordion expanded={isExpanded} onChange={() => setIsEpanded((prev) => !prev)} disableGutters >
            <AccordionSummarySlim>
                <Typography>
                    {tm.Get("Permissions")}
                </Typography>
            </AccordionSummarySlim>
            <AccordionDetails>
                <Grid container spacing={1} padding={0}>
                    <Grid item xs={6} mt={1}>
                        <SelectForm
                            fieldName="securityLevel"
                            dataSource={GetEnumAsListOfKeyValuePairs(Object.values(SecurityLevelEnum))}
                            keyField="key"
                            valueField="value"
                            displayField="key"
                            translateDisplayField={true}
                            label={tm.Get("Type")}
                            onChange={handleSecurityLevelChange}
                            readOnly={readOnly}
                            disabled={securityLevelDisabled && !readOnly}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Divider />
                    </Grid>
                    {fields.map((field, index) => {
                        const label = watch(`permissions.${index}.description`);

                        return <Grid item xs={12} key={field.id}>
                            <CheckBoxForm
                                readOnly={readOnly}
                                fieldName={`permissions.${index}.enabled`}
                                label={tm.Get(label)}
                                disabled={disabled && !readOnly}
                            />
                        </Grid>
                    })}
                </Grid>
            </AccordionDetails>
        </Accordion>
    </>;
}

export default PermissionSelect;